@if (isOpen) {
  <div
    class="ted-overlay"
    tabindex="-1"
    aria-hidden="true"
    (click)="onOverlayClick()"
    (keydown.escape)="onClose()"
  ></div>
  <div
    class="ted-panel"
    role="dialog"
    aria-label="Ted - Data Assistant"
    aria-modal="true"
  >
    <div class="panel-header">
      <div class="header-left">
        <div class="ted-avatar">
          <div class="ted-icon-wrap">
            <g99-icon-btn
              [icon]="tedIcon"
              [height]="20"
              [width]="20"
              [padding]="0"
              [backgroundColor]="'transparent'"
              [colorStrategy]="'none'"
              [isDisabled]="true"
            />
            <span class="ted-label">TED</span>
          </div>
        </div>
        <div>
          <p class="title">Ted</p>
          <p class="subtitle">Data Assistant</p>
        </div>
      </div>
      <button
        class="close-btn"
        type="button"
        aria-label="Close Ted"
        (click)="onClose()"
      >
        <g99-icon-btn
          [icon]="closeIcon"
          [height]="18"
          [width]="18"
          [padding]="0"
          [backgroundColor]="'transparent'"
          [color]="'currentColor'"
          [colorStrategy]="'both'"
        />
      </button>
    </div>
    <div class="panel-body">
      <g99-lib-ted-chat />
    </div>
  </div>
}
